import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import AddTask from '@mui/icons-material/AddTask';
import Delete from '@mui/icons-material/Delete';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

export const FormType = ({ values = [], onFieldsChange, t }) => {
    const initState = () => ({
        id: '',
        label: '',
        type: '',
        required: false
    })
    const [formValues, setFormValues] = useState(initState());
    const [obj, setObj] = useState(values);
    const [visibleTable, setvisibleTable] = useState(false);

    const handleAdd = () => {
        setObj(prevItems => [...prevItems, formValues]);
        setFormValues(initState());
    };

    const handleDelete = (index) => {
        setObj(obj.filter((_, i) => i !== index));
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    useEffect(() => {
        onFieldsChange(obj);
    }, [obj]);

    return (
        <Box>
            <Grid container spacing={2} alignItems="center">
                <Grid size={{xs:10, sm:10}}>
                    <Typography variant='h6' component='h6'>
                        {t("common.formFieldsTitle")}
                    </Typography>
                </Grid>
                <Grid size={{xs:2, sm:2}} sx={{ display: 'flex' }}>
                    <Tooltip title={t("delete")}>
                        <IconButton
                            aria-label="close"
                            onClick={handleAdd}
                            sx={{
                                color: 'blue',
                            }}
                        >
                            <AddTask />
                        </IconButton>
                    </Tooltip>
                    {obj.length > 0 && (
                        <Tooltip title={visibleTable ? 'Ocultar tabla' : 'Mostrar tabla'}>
                            <IconButton
                                aria-label="close"
                                onClick={() => setvisibleTable(!visibleTable)}
                                sx={{
                                    color: 'blue',
                                }}
                            >
                                {visibleTable ?
                                    <ExpandLess />
                                    :
                                    <ExpandMore />
                                }
                            </IconButton>
                        </Tooltip>
                    )}
                </Grid>
                <Grid size={{xs:12, sm:6}}>
                    <TextField
                        required
                        fullWidth
                        label='Id del campo'
                        variant='outlined'
                        name='id'
                        size='small'
                        value={formValues.id}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid size={{xs:12, sm:6}}>
                    <TextField
                        required
                        fullWidth
                        label='Label'
                        size='small'
                        variant='outlined'
                        name='label'
                        value={formValues.label}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid size={{xs:12, sm:6}}>
                    <FormControl
                        fullWidth
                        size='small'
                        required
                    >
                        <InputLabel id="type">Tipo</InputLabel>
                        <Select
                            label="Tipo"
                            name='type'
                            value={formValues.type}
                            onChange={handleChange}
                        >
                            {
                                ['text', 'select', 'switch', 'MLEditor'].map((option, idx) => (
                                    <MenuItem key={idx} value={option}>{option}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{xs:12, sm:6}}>
                    <FormGroup style={{ width: '100%' }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="required"
                                    checked={formValues.required || false}
                                    onChange={(e) => setFormValues({ ...formValues, required: e.target.checked })}
                                />
                            }
                            label='Required'
                        />
                    </FormGroup>
                </Grid>
                {
                    formValues.type === 'select' &&
                    <Grid size={{xs:12, sm:6}}>
                        <TextField
                            required
                            fullWidth
                            label='Valores posibles'
                            size='small'
                            variant='outlined'
                            name='values'
                            value={formValues.values}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                }

            </Grid>

            {obj.length > 0 && visibleTable && (
                <TableContainer sx={{ marginTop: 3 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell key={'idCol'}>Id campo</TableCell>
                                <TableCell key={'idCol'}>Nombre</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {obj.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <IconButton color="error" onClick={() => handleDelete(index)}>
                                            <Delete />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>{row.id}</TableCell>
                                    <TableCell>{row.label}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};
